import { View } from "react-native";

export function Overlap<T>(props: {
  maxNumberOfItems?: number;
  data: readonly T[];
  render: (item: T) => React.ReactNode;
  viewWidth: number;
  overlapRatio?: number;
  direction?: "start" | "end";
}) {
  const overlapRatio = props.overlapRatio || 0.25;
  const overlap = props.viewWidth * overlapRatio;
  const direction = props.direction ?? "start";
  return (
    <View style={{ flexDirection: "row", alignItems: "center" }}>
      {props.data
        .slice(
          props.maxNumberOfItems === undefined
            ? undefined
            : -props.maxNumberOfItems
        )
        .map((e, index, arr) => (
          <View
            key={index}
            style={{
              zIndex: direction === "start" ? -index : index - arr.length,
              marginLeft: index === 0 ? 0 : -overlap,
            }}
          >
            {props.render(e)}
          </View>
        ))}
    </View>
  );
}
